import { render, staticRenderFns } from "./ResultPreview.vue?vue&type=template&id=1b707e94&scoped=true&"
import script from "./ResultPreview.vue?vue&type=script&lang=js&"
export * from "./ResultPreview.vue?vue&type=script&lang=js&"
import style0 from "./ResultPreview.vue?vue&type=style&index=0&id=1b707e94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b707e94",
  null
  
)

export default component.exports